import { UrlConfig } from 'config';
import { ApiResponse } from 'models/Api/ApiResponse';
import WaitlistModel from 'models/Waitlist/Waitlist';
import { RawWaitlistData, WaitlistStatus } from 'models/Waitlist/types';
import { AjaxService } from 'services';

export class WaitlistApiClient {
  public static async joinUserWaitlist(email: string): Promise<void> {
    const url = UrlConfig.WAITLIST.CREATE;
    await AjaxService.postData(url, {
      email
    });
  }

  public static async getWaitlistsByStatus(status: WaitlistStatus): Promise<WaitlistModel[]> {
    const url = UrlConfig.WAITLIST.STATUS + status;
    const response: ApiResponse<RawWaitlistData[]> = await AjaxService.getData(url);
    return response.data.map((rawWaitlist) => new WaitlistModel(rawWaitlist));
  }

  public static async approveWaitlist(waitlistId: string): Promise<string> {
    const url = UrlConfig.WAITLIST.APPROVE;
    await AjaxService.postData(url, { user_waitlist_id: waitlistId });
    return waitlistId;
  }

  public static async rejectWaitlist(waitlistId: string): Promise<string> {
    const url = UrlConfig.WAITLIST.REJECT;
    const payload = { user_waitlist_id: waitlistId };
    await AjaxService.postData(url, payload);
    return waitlistId;
  }
}
